export const SET_QRCODE_OBJECT = "SET_QRCODE_OBJECT";
export const SET_VIDEO_URL = "SET_VIDEO_URL";
export const SET_AUDIO_URL = "SET_AUDIO_URL";
export const SET_CUSTOM_HTML = "SET_CUSTOM_HTML";
export const SET_CUSTOM_FULL_HTML = "SET_CUSTOM_FULL_HTML";
export const SET_CUSTOM_JS = "SET_CUSTOM_JS";
export const RAISE_QRCODE_ERROR = "RAISE_QRCODE_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const SET_WEBAR_URL = "SET_WEBAR_URL";
export const SET_CURRENT_PHOTOS = "SET_CURRENT_PHOTOS";

export default {
    SET_QRCODE_OBJECT,
    SET_VIDEO_URL,
    SET_AUDIO_URL,
    SET_CUSTOM_HTML,
    SET_CUSTOM_FULL_HTML,
    SET_CUSTOM_JS,
    RAISE_QRCODE_ERROR,
    CLEAR_ERROR,
    SET_WEBAR_URL,
    SET_CURRENT_PHOTOS: "SET_CURRENT_PHOTOS"
};
